import { useEffect, useState } from 'react';

import { formatIstDateTime } from '@/lib/istClock';

/** Live IST wall clock, for the call chrome and the recording overlay. */
export function useIstClock(withSeconds = true): string {
  const [label, setLabel] = useState(() => formatIstDateTime(new Date(), withSeconds));

  useEffect(() => {
    const tick = () => setLabel(formatIstDateTime(new Date(), withSeconds));
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [withSeconds]);

  return label;
}
